<template>
  <div class="counters">
    <div class="counters__counter" v-if="hasActiveSlot">
      <div class="counters__counter--number"><slot name="active"></slot></div>
      <div class="counters__counter--name">{{ $t('common.active') }}</div>
    </div>
    <div class="counters__counter">
      <div class="counters__counter--number"><slot name="total"></slot></div>
      <div class="counters__counter--name">{{ $t('common.total') }} </div>
    </div>
    <!--
    <div class="counters__counter">
      <div class="counters__counter--number"><slot name="issued"></slot></div>
      <div class="counters__counter--name">{{ $t('common.issued') }}</div>
    </div>
    <div class="counters__counter">
      <div class="counters__counter--number orange"><slot name="available"></slot></div>
      <div class="counters__counter--name">{{ $t('counters.available') }}</div>
    </div>-->
  </div>
</template>

<script>
export default {
  computed: {
    hasActiveSlot() {
      return !!this.$slots.active;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/variables.scss';
.counters {
  display: flex;
  &__counter {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;
    margin: 0 30px;

    &--number {
      font-size: 24px;
    }

    &--name {
      color: var(--disabled-color);
      font-size: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Counters.vue